var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.78 8.02a6.4 6.4 0 11-12.8 0 6.4 6.4 0 0112.8 0zM6.659 9.456a.8.8 0 10-1.131 1.131 4 4 0 005.656 0 .8.8 0 00-1.132-1.131 2.4 2.4 0 01-3.393 0zm2.583-3.99a2.466 2.466 0 011.776-.76c.672 0 1.31.277 1.776.76a.8.8 0 01-1.152 1.11.866.866 0 00-.624-.27.866.866 0 00-.624.27.8.8 0 11-1.152-1.11zm-3.497-.76c-.672 0-1.31.277-1.776.76a.8.8 0 001.152 1.11.866.866 0 01.624-.27c.228 0 .453.093.624.27a.8.8 0 101.152-1.11 2.466 2.466 0 00-1.776-.76z",
    fill: "#E9B73D"
  })));
}
export default SvgHaha;